import { useMemo, useState } from "react";
import { Modal, Tabs } from "antd";
import UserItem from "../../../../components/shared/UserItem";

const ReactionsList = ({ reactions = [], users = [] }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("all");

  const usersMap = useMemo(() => {
    return Object.fromEntries(users.map((u) => [u.id, u]));
  }, [users]);

  const { grouped, filteredReactions, tabItems } = useMemo(() => {
    const grouped = reactions.reduce((acc, { emoji, ...rest }) => {
      (acc[emoji] ||= []).push({ emoji, ...rest });
      return acc;
    }, {});

    const filteredReactions =
      activeTab === "all" ? reactions : (grouped[activeTab] ?? []);

    const tabItems = [
      {
        key: "all",
        label: `All ${reactions.length}`,
      },
      ...Object.entries(grouped).map(([emoji, arr]) => ({
        key: emoji,
        label: `${emoji} ${arr.length}`,
      })),
    ];

    return { grouped, filteredReactions, tabItems };
  }, [reactions, activeTab]);

  return (
    <>
      <div className="reactions-bar">
        {reactions.length > 0 && (
          <div
            className="reaction-bubble"
            onClick={() => {
              setActiveTab("all");
              setModalOpen(true);
            }}
          >
            {Object.keys(grouped).map((emoji) => (
              <span key={emoji} className="reaction-emoji">
                {emoji}
              </span>
            ))}
            <span className="reaction-count">{reactions.length}</span>
          </div>
        )}
      </div>
      <Modal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        title={null}
        styles={{ body: { padding: 0 } }}
      >
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabItems}
          className="reactions-tabs"
        />
        <div className="flex-col">
          {filteredReactions.map((reaction) => (
            <UserItem user={usersMap[reaction.sender_id]}>
              <span style={{ fontSize: "25px" }}>{reaction.emoji}</span>
            </UserItem>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default ReactionsList;
